import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, MonetaryValue } from '../fields';

export const HistoricalDrawRow = z.object({
  loanId: LosId,
  // Blank cells normalize to undefined so they store as NULL instead of ""
  // colliding in the (loan_id, transaction_id) unique index.
  transactionId: z
    .string()
    .transform((value) => value.trim() || undefined)
    .optional(),
  drawDate: DateString,
  method: z.string().optional(),
  description: z.string().optional(),
  total: MonetaryValue,
});

export type HistoricalDrawRow = z.infer<typeof HistoricalDrawRow>;

export const HISTORICAL_DRAW_ROW_REQUIRED_FIELDS = Object.keys(HistoricalDrawRow.shape).filter(
  (key) => !HistoricalDrawRow.shape[key as keyof typeof HistoricalDrawRow.shape].isOptional(),
);
